// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import React from 'react';
import { Typography } from '../../../lib/base';

interface Props {
  readonly children: string;
}

export default function DialogInfochildren({ children }: Props) {
  return <Typography variant="h6">{children}</Typography>;
}
